import { render } from "./HistoryUseCouponInOrder.vue?vue&type=template&id=13b9c5b2&scoped=true"
import script from "./HistoryUseCouponInOrder.vue?vue&type=script&lang=js"
export * from "./HistoryUseCouponInOrder.vue?vue&type=script&lang=js"

import "./HistoryUseCouponInOrder.vue?vue&type=style&index=0&id=13b9c5b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b9c5b2"]])

export default __exports__